import React from 'react';
import Modal from '../../../Components/Modal';
import JobDetails from '../../../Components/Formatting/Grids/JobDetails';
import Button from '../../../Components/Button/Button';
import Callback from '../../../Services/Callback';
import ButtonRow from '../../../Components/Button/ButtonRow';
import { getEntityLink } from '../../../Services/helpers';
import Alert from '../../../Components/Alert';
import ButtonGap from '../../../Components/Button/ButtonGap';
import { useCalendarContext } from '../Provider';

const closer = new Callback();

const Appointment = ({appointment, onClose}) => {
    const {setSchedulingJob, schedulingJob} = useCalendarContext();

    if (!appointment) {
        return null;
    }

    return <Modal title="Job details" isOpen={!!appointment} setIsOpen={onClose} dismissible={!schedulingJob} closer={closer}>
        <StatusAlert status={appointment.status} />

        <JobDetails job={appointment.job} customer={appointment.customer} />

        <ButtonRow>
            <Button theme="light"
                // icon="CalendarPen"
                label="Reschedule"
                onClick={() => setSchedulingJob(appointment.job)}
            />
            <Button theme="light"
                // icon="User"
                label="Customer"
                link={getEntityLink('Customers/Customer', appointment?.customer?.id)}
            />
            <ButtonGap />
            <Button theme="secondary" label="Close" onClick={() => closer.invoke()} />
        </ButtonRow>
    </Modal>
}

const StatusAlert = ({status}) => {
    if (status === 'Invalidated') {
        return <Alert theme="warning"
            title="Recheduled"
            message={<>
                This job has been rescheduled.<br />
                Select 'Replan route' from the day's menu to update the plan for the day without rescheduled jobs.
            </>}
        />
    }

    if (status === 'Tentative') {
        return <Alert theme="info"
            title="Tentative"
            message={<>
                This job has hasn't been scheduled.<br />
                Select 'Confirm' for the day or week to schedule tentative jobs and update their status.
            </>}
        />
    }

    if (status === 'Scheduled Manually') {
        return <Alert theme="info"
            title="Scheduled Manually"
            message={<>
                This job was scheduled without using the calendar planner.<br />
                The time at this job hasn't been taken into account when other jobs were planned using the calendar.
            </>}
        />
    }

    return null;
}

export default Appointment;
